import { delay, HttpHandler, HttpResponse } from "msw";
import type { Plan } from "~/types/entities/finance";
import type { BillingHistoryItem, SavedCard } from "~/types/finance";

const setupMockEndpointUrl = (path: string) => {
  if (!path.startsWith("mock/")) return "";
  if (!tryUseNuxtApp()) return path;
  const { apiUrl } = useRuntimeConfig().public;
  if (apiUrl)
    return new URL(path, `${apiUrl}`.replace(/\/\/$/, "/")).toString();
  return path;
};

export function getMockAPIHandlers() {
  const handlers: HttpHandler[] = [
    new HttpHandler("GET", setupMockEndpointUrl("mock/cards"), async () => {
      await delay(2000);
      return HttpResponse.json<{ data: SavedCard[] }>({
        data: fakeCards,
      });
    }),
    new HttpHandler("POST", setupMockEndpointUrl("mock/cards"), async () => {
      await delay(2000);
      return HttpResponse.json({});
    }),
    new HttpHandler("GET", setupMockEndpointUrl("mock/billing"), async () => {
      await delay(2000);
      return HttpResponse.json<{ data: BillingHistoryItem[] }>({
        data: fakeBillingHistory,
      });
    }),
    new HttpHandler(
      "GET",
      setupMockEndpointUrl("mock/subscription/plans"),
      async () => {
        await delay(2000);
        return HttpResponse.json<{ data: Plan[] }>({
          data: fakePlans,
        });
      },
    ),
    new HttpHandler(
      "GET",
      setupMockEndpointUrl("mock/subscription/plans/:planId"),
      async ({ params }) => {
        await delay(2000);
        return HttpResponse.json<{ data: Plan }>({
          data: isNaN(+params.planId)
            ? fakePlans[0]
            : fakePlans.find((plan) => +plan.id === Number(params.planId))!,
        });
      },
    ),
  ];
  return handlers;
}
